import React, { useState } from 'react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { NeutralColors } from '@fluentui/react';
import {
  Checkbox,
  Select,
  Label,
  FluentProvider,
  webLightTheme,
  makeStyles,
} from '@fluentui/react-components';
import { bodyContentContainer } from '../../../app/common/styles/CommonStyleObjects';
import { multiDropdownLargeWrapper } from './CompanyDocumentStyles';
import { bodyContent } from '../../common/headers/Headers.styles';
import MilestoneDocuments from './MilestoneDocuments';
import ProcessExtensionDocuments from './ProcessExtensionDocuments';
import CompanyDocuments from './CompanyDocuments';

const useStyles = makeStyles({
  checkboxPadding: { paddingTop: '15px' },
});

const CompanyDocumentsPage = (): JSX.Element => {
  const classes = useStyles();
  const [documentType, setDocumentType] = useState('Milestone');
  const [showDeletedFiles, setShowDeletedFiles] = useState(false);
  const cardWrapperStyles = { padding: '15px 0', background: NeutralColors.white };

  return (
    <FluentProvider theme={webLightTheme}>
      <div className={bodyContentContainer}>
        <div className="ms-depth-4" style={cardWrapperStyles}>
          <Stack horizontal verticalAlign="center" horizontalAlign="space-between">
            <div className={bodyContent().bodyContentTitle} style={{ padding: '0 25px' }}>
              <Label id="documentTypeDropdown">Document Type</Label>
              <Select
                aria-labelledby="documentTypeDropdown"
                className={multiDropdownLargeWrapper}
                defaultValue={documentType}
                onChange={(event): void => {
                  setDocumentType(event.target.value);
                }}
                placeholder="Select an option"
              >
                <option value="Milestone">Milestone Documents</option>
                <option value="ProcessExtension">Process Extension Documents</option>
                <option value="Company">Company Documents</option>
              </Select>
              <Stack className={classes.checkboxPadding} horizontal>
                <Checkbox
                  aria-label="Show recycled documents"
                  label="Show recycled documents"
                  onChange={(ev, data): void => {
                    setShowDeletedFiles(data.checked === true);
                  }}
                />
              </Stack>
            </div>
          </Stack>
          {documentType === 'Milestone' && (
            <MilestoneDocuments showDeletedFiles={showDeletedFiles} />
          )}
          {documentType === 'ProcessExtension' && (
            <ProcessExtensionDocuments showDeletedFiles={showDeletedFiles} />
          )}
          {documentType === 'Company' && <CompanyDocuments showDeletedFiles={showDeletedFiles} />}
        </div>
      </div>
    </FluentProvider>
  );
};
export default CompanyDocumentsPage;
